import styled from 'styled-components'

const Button = styled.button`
  width: 38px;
  height: 38px;
  border: ${(p) => `solid ${p.theme.uiKit.colors.global.grey.grey300} ${p.theme.uiKit.borderWidth.strokeS};`};
  background-color: #fff;
  border-radius: 3px;
  cursor: pointer;

  transition:
    background 0.15s,
    color 0.15s,
    outline 0.15s,
    box-shadow 0.15s,
    border-color 0.15s;

  &:hover {
    border: ${(p) => `solid ${p.theme.uiKit.colors.global.grey.grey100} ${p.theme.uiKit.borderWidth.strokeS};`};
    background-color: ${(p) => p.theme.uiKit.colors.global.grey.grey100};
  }
`

const ButtonActive = styled.button`
  width: 38px;
  height: 38px;
  border: ${(p) => `solid ${p.theme.uiKit.colors.theme.positive.darker} ${p.theme.uiKit.borderWidth.strokeS};`};
  background-color: #fff;
  border-radius: 3px;
  cursor: pointer;

  transition:
    background 0.15s,
    color 0.15s,
    outline 0.15s,
    box-shadow 0.15s,
    border-color 0.15s;

  &:hover {
    border: ${(p) => `solid ${p.theme.uiKit.colors.global.grey.grey100} ${p.theme.uiKit.borderWidth.strokeS};`};
    background-color: ${(p) => p.theme.uiKit.colors.global.grey.grey100};
  }
`

export const s = { Button, ButtonActive }
